import { useMutation } from '@tanstack/react-query';
import { deleteRecord } from 'config/requests';
import { queryClient } from 'providers/queryClient';
import { Form, useNotify } from 'react-admin';
import { Button } from 'shared/mui/Buttons';
import { CardActionsButtons, CardHeader } from 'shared/mui/Card';
import { CardContent } from 'shared/mui/Card/CardContent/CardContent';
import { Dialog } from 'shared/mui/Dialogs';
import { CloseIconButton } from 'shared/mui/IconButtons';
import { TypographyBold } from 'shared/mui/Typography/TypographyBold';
import { MerchantCredentials } from 'types/embedded/merchant';

type Props = {
  open: boolean;
  onClose: () => void;
  record: MerchantCredentials | undefined;
};

export const MerchantsShowCredentialsDeleteDialog: React.FC<Props> = ({
  open,
  onClose,
  record,
}) => {
  const notify = useNotify();

  const { mutate } = useMutation({
    mutationFn: () => deleteRecord(record?.id || ''),
    onSuccess: async () => {
      notify(
        <>
          Реквизит доступа <TypographyBold text={record?.name || ''} /> удалён
        </>,
        { type: 'success' },
      );
      await queryClient.invalidateQueries({ queryKey: ['merchant_credentials'] });
      onClose();
    },
    onError: (error: any) => {
      notify(`Ошибка: ${error?.data?.detail}`, { type: 'error' });
    },
  });

  const onSubmit = () => {
    mutate();
  };

  return (
    <Dialog onClose={onClose} open={open} width="640px">
      <Form onSubmit={onSubmit as any}>
        <CardHeader
          appendActions={[<CloseIconButton key="close-button" onClose={onClose} />]}
          title="Удаление реквизитов доступа"
          titleSize="smallBold"
        />
        <CardContent>
          Реквизиты доступа <TypographyBold fontSize={16} text={record?.name || ''} /> будут удалены
          без возможности восстановления.
        </CardContent>
        <CardActionsButtons
          rightActionsSlot={[
            <Button key="cancel" label="Отменить" onClick={onClose} variant="outlined" />,
            <Button color="error" key="delete" label="Удалить" type="submit" variant="contained" />,
          ]}
        />
      </Form>
    </Dialog>
  );
};
